import CustomersTimelinePage from './customer-timeline-page'

import withRedux from './with-redux'

export default withRedux(CustomersTimelinePage)